var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { ChevronDown } from '../../../foundations/icons';
import styles from './ChevronIcon.module.scss';
export var ChevronIcon = function (_a) {
    var _b;
    var isOpen = _a.isOpen, className = _a.className, props = __rest(_a, ["isOpen", "className"]);
    var classNames = cx(styles.icon, (_b = {}, _b[styles.down] = isOpen, _b), className);
    return React.createElement(ChevronDown, __assign({ size: "small", className: classNames, "data-testid": "chevron-icon" }, props));
};
//# sourceMappingURL=ChevronIcon.js.map